import { API } from '@shared/types/api';

// https://github.com/coast-app/core-api/blob/master/packages/core-models/src/workflow-template/components/InputComponentTypes.ts
const INPUT_COMPONENT_TYPES = [
  'ADDRESS',
  'AUDIT_CHECKBOX',
  'AUDIT_TAG',
  'AUDIT_TEXT',
  'DATE',
  'EMAIL',
  'ENTITY_BATCH',
  'FILE',
  'GEOLOCATION',
  'NUMBER',
  'PERSON',
  'RELATED_CARD',
  'RELATED_CARD_LOOKUP',
  'SCHEDULED_AUTOMATION',
  'SIGNATURE',
  'SUBFORM',
  'TAG',
  'TEXT',
  'TIME_TRACKER',
  'TODO',
  'URL',
] as const;

export type InputComponentType = (typeof INPUT_COMPONENT_TYPES)[number];

export const INPUT_COMPONENT_TYPE_VALUES: readonly string[] = INPUT_COMPONENT_TYPES;

export type InputComponent =
  | API.AddressComponentFragment
  | API.AuditCheckboxComponentFragment
  | API.AuditTagComponent
  | API.AuditTextComponentFragment
  | API.DateComponent
  | API.EmailComponentFragment
  | API.EntityBatchComponentFragment
  | API.FileComponent
  | API.GeolocationComponentFragment
  | API.NumberComponent
  | API.PersonComponentFragment
  | API.RelatedCardComponent
  | API.RelatedCardLookupComponent
  | API.ScheduledAutomationComponentFragment
  | API.SignatureComponent
  | API.SubformComponent
  | API.TagComponent
  | API.TextComponent
  | API.TimeTrackerComponent
  | API.TodoComponent
  | API.UrlComponent;
